import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Subscription } from 'rxjs';

export function MatchValidator(controlNameToCompare: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === null || control.value.lenght === 0) {
      return null;
    }
    const controlToCompare = control.root.get(controlNameToCompare);
    if (controlToCompare) {
      const sub: Subscription = controlToCompare.valueChanges.subscribe(() => {
        control.updateValueAndValidity();
        sub.unsubscribe();
      });
    }
    return controlToCompare && controlToCompare.value !== control.value
      ? { matched: true }
      : null;
  };
}
